module.exports = __webpack_public_path__ + "media/images/common/shop/arrow-80c073e5411b6375d909009c9b27a6e6.svg";